import {ajax, getRequestUrl, uploadImg} from "../request";

export default {
  getListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/getListByPage'), data, {
      method,
    });
  },

  addInvite(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/addInvite'), data, {
      method,
    });
  },

  getDetailByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/getDetailByPage'), data, {
      method,
    });
  },

  bindInvite(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bindInvite'), data, {
      method,
    });
  },

  unbind(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/unbind'), data, {
      method,
    });
  },

  bindInviteExcel(data) {
    return uploadImg(getRequestUrl('/api/Invite/bindInviteExcel'), data)
  },

  deleteInvite(data,method) {
    return ajax('post', getRequestUrl('/api/Invite/deleteInvite'), data, {
      method,
    });
  },

  usdRank(data,method) {
    return ajax('post', getRequestUrl('/user_invite/usd_rank'), data, {
      method,
    });
  },
  userUSDDetail(data,method) {
    return ajax('post', getRequestUrl('/user_invite/user_usd_detail'), data, {
      method,
    });
  },

  goldRank(data,method) {
    return ajax('post', getRequestUrl('/user_invite/gold_rank'), data, {
      method,
    });
  },

  promoterList(data,method) {
    return ajax('post', getRequestUrl('/user_invite/promoter_list'), data, {
      method,
    });
  },

  getSettleList(data,method) {
    return ajax('post', getRequestUrl('/user_invite/settle_day'), data, {
      method,
    });
  },

  inviteBigboard(data,method) {
    return ajax('post', getRequestUrl('/user_invite/bigboard'), data, {
      method,
    });
  },

  inviteUSDUserList(data,method) {
    return ajax('post', getRequestUrl('/user_invite/user_list'), data, {
      method,
    });
  },

  inviteFailList(data,method) {
    return ajax('post', getRequestUrl('/user_invite/bind_fail_list'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/Invite.js